import { Group, Text, Title } from "@mantine/core"

import { Card, CardProps } from "../../layout/Card/Card"
import { ToggleCollapse } from "../../molecules/Buttons/ToggleCollapse/ToggleCollapse"

export type FormGroupProps = {
  children: React.ReactNode
  title?: string
  description?: string
  collapsible?: boolean
  collapsed?: boolean
  variant?: "default" | "filled" | "outline"
  spacing?: "xs" | "sm" | "md" | "lg" | "xl"
  toggleCollapse?: () => void
  open?: boolean
} & CardProps

export const FormGroup = ({
  children,
  title,
  description,
  collapsible,
  collapsed,
  toggleCollapse,
  ...props
}: FormGroupProps) => {
  return (
    <Card {...props}>
      <Group w="100%" justify="space-between" pb="xs">
        {title && (
          <Title order={6} fw={600}>
            {title}
          </Title>
        )}
        {collapsible && toggleCollapse && (
          <ToggleCollapse
            open={!collapsed}
            toggle={toggleCollapse}
            iconSize={16}
            color="var(--mantine-color-gray-6)"
          />
        )}
      </Group>
      {description && <Text>{description}</Text>}
      {children}
    </Card>
  )
}
